module.exports = __webpack_public_path__ + "img/direction-2@2x.f95aeec0.png";